var React = require('react');

function Other (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","stroke":"#000","strokeLinejoin":"round","strokeMiterlimit":"10","strokeWidth":"4"},[React.createElement("circle",{"cx":"98.98","cy":"28.77","r":"18.02","key":0}),React.createElement("circle",{"cx":"98.98","cy":"99.73","r":"18.02","key":1}),React.createElement("circle",{"cx":"28.02","cy":"63.7","r":"18.02","key":2}),React.createElement("path",{"d":"m82.63 38.47-36.59 18.3","key":3}),React.createElement("path",{"d":"m80.41 92.8-36.59-18.29","key":4})]));
}

Other.defaultProps = {"viewBox":"0 0 128 128"};

module.exports = Other;

Other.default = Other;
